<template>
	<div class="main">
		<div class="changcar">
			<div class="chang-top">修改项目类别 <div class="exit" @click="exit">
					✖
				</div>
			</div>
			<div class="chang-content">
				<div class="chang-title">
					<div class="chang-type" v-for="(item,index) in menu" :key="index">
						<div class="left-title" @click="typelist(index)" :class="{'left-title1':index==Sindex}">
							{{item.name}}
						</div>
						<div class="left-list" v-if="index==Sindex" v-for="(res,i) in item.list" :key="i"
							:class="{'left-list1':i==Sxindex}" @click="gzlist(i,res)">
							{{res.projectType}}
						</div>
					</div>
				</div>
				<div class="chang-list">
					<div class="list-car" v-for="(item,index) in gzs" :key="index" @click="xzgz(index,item)"
						:class="{'list-car1':index==Sgzindex}">
						{{item.industryTypeName}}
					</div>
				</div>

			</div>
			<div class="chang-but">
				<el-button type="primary" @click="but">确定修改</el-button>
				<el-button type="warning" @click="exit">放弃修改</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Setitem,
		Getitem
	} from "../../utils/item.js";
	import {
		subclass,
		zyemg,
		prjpush
	} from "../../utils/request.js";
	export default {
		data() {
			return {
				menu: Getitem('setmenu'),
				Sindex: -1,
				Sxindex: -1,
				Sgzindex: -1,
				gzs: [],
				gzprj: {}

			};
		},
		methods: {
			exit() {
				this.$emit('close')
			},
			but() {
				if (JSON.stringify(this.gzprj) == '{}') return
				this.$emit('editg', this.gzprj)
				this.exit()


			},
			xzgz(index, item) {
				if (this.Sgzindex == index) {
					this.Sgzindex = -1
				} else {
					this.Sgzindex = index

				}


				this.gzprj = item

			},

			gzlist(i, res) {
				this.gzprj = {}
				this.Sxindex = -1
				this.Sgzindex = -1
				this.Sxindex = i
				this.gz(res)

			},
			typelist(index) {
				this.gzprj = {}
				this.Sxindex = -1
				if (this.Sindex == index) {
					this.Sindex = -1
				} else {
					this.Sindex = index

				}
			},
			async gz(res) {
				let li = await subclass(res.projectTypeId);
				if (li.code === 200) {
					this.gzs = li.list
				} else {
					this.$toast.error(li.msg)
				}
			}
		},
		created() {},
		components: {

		},
		watch: {


		},


	};
</script>

<style lang="less" scoped>
	.main {
		width: 100vw;
		height: 100vh;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 350;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;

		// <div class="changcar">
		// 	<div class="log-title">
		// 		<el-button type="primary" @click="runlogin">重新登录</el-button>
		// 		<el-button type="warning" @click="exitlogin">放弃登录</el-button>
		// 	</div>
		// </div>
		.changcar {
			width: 70vw;
			height: 54vh;
			background-color: #e7e7e7;
			padding: 15px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			border-radius: 8px;

			.chang-top {
				width: 100%;
				height: 4vh;
				border-bottom: 1px solid #bfbfbf;
				font-size: 23px;
				font-weight: 500;
				position: relative;

				.exit {
					position: absolute;
					top: 0;
					right: 15px;
					color: red;
					cursor: pointer;
				}

				.exit:hover {
					color: blue;
				}

			}

			.chang-content {
				width: 100%;
				height: 44vh;
				display: flex;
				justify-content: space-around;

				.chang-title {
					height: 95%;
					width: 20%;
					border-right: 1px solid #bfbfbf;
					border-bottom: 1px solid #bfbfbf;

					box-shadow: -2px -2px 2px rgba(0, 0, 0, 0.6);
					border-radius: 3px;
					padding: 10px 0;
					display: flex;
					flex-direction: column;
					align-items: center;
					overflowY: auto;
					scrollbar-width: none;
					-ms-overflow-style: none;

					// margin-right: 15px;
					.chang-type {
						width: 95%;
						cursor: pointer;
						display: flex;
						flex-direction: column;
						align-items: end;

						.left-title {
							width: 95%;
							font-size: 15px;
							text-align: left;
							font-weight: 500;
							height: 30px;
							border-bottom: 1px solid #cacaca;
							display: flex;
							align-items: center;
							margin-bottom: 5px;
							// background-color: aqua;

						}


						.left-title:hover {
							color: #37b9ff !important;
						}

						.left-list:hover {
							color: rgb(250, 152, 152) !important;
						}


						.left-title1 {
							color: #409eff !important;
							font-weight: bold;
						}

						.left-list1 {
							color: rgb(196, 86, 86) !important;
							font-weight: bold;
						}

						.left-list {
							height: 25px;
							text-align: left;
							width: 85%;
							font-size: 13px;
						}
					}


					// <div class="chang-type" v-for="(item,index) in menu">
					// 	<div class="left-title">
					// 		{{item.name}}
					// 	</div>
					// </div>
				}

				.chang-list {
					height: 95%;
					width: 76%;
					border-left: 1px solid #bfbfbf;
					border-bottom: 1px solid #bfbfbf;
					box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.6);
					border-radius: 3px;
					padding: 10px;
					display: flex;
					flex-wrap: wrap;
					align-items: flex-start;
					justify-content: start;
					overflow-y: auto;
					overflow-x: hidden;
					scrollbar-width: none;
					-ms-overflow-style: none;
					align-content: flex-start;
					// line-height: 50px;

					.list-car {
						padding: 5px 8px;
						border-radius: 3px;
						border: 1px solid #cacaca;
						margin: 8px;
						box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6);
						cursor: pointer;
					}

					.list-car:hover {
						background-color: #2cceff !important;
						box-shadow: 0px 0px 0px rgba(0, 0, 0, 0)
					}

					.list-car1 {
						background-color: #297bff !important;
						box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
						color: #e7e7e7;
					}



				}

			}

			.chang-but {
				width: 50%;
				height: 4vh;
				display: flex;
				align-items: center;
				justify-content: space-around;

			}




		}

	}
</style>